import useMediaQuery from '@mui/material/useMediaQuery';

const useScreenMedium: Function = (isShort?: boolean): boolean => {
  const SCREEN_MAX_WIDTH_MEDIUM: number = 1279;
  const SCREEN_MAX_WIDTH_MEDIUM_SHORT: number = 1115;

  return useMediaQuery(`(max-width: ${isShort ? SCREEN_MAX_WIDTH_MEDIUM_SHORT : SCREEN_MAX_WIDTH_MEDIUM}px)`);
};

export default useScreenMedium;
